<template>
    <div
        :class="componentClasses"
        :title="props.user.name.firstName"
    >
        <img
            v-if="hasAvatar"
            class="employee-avatar-icon__img"
            :src="props.user.avatar"
            :alt="props.user.name.firstName"
        />
        <div
            v-else
            class="employee-avatar-icon__initial"
            v-text="inital"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import type { User } from '@/chat/types/User';

    const props = withDefaults(defineProps<{
        user: User,
        smaller?: boolean,
        round?: boolean,
    }>(), {
        smaller: false,
        round: false,
    });

    const hasAvatar = computed(() => {
        return !!props.user.avatar;
    });

    const inital = computed(() => {
        return props.user.name.firstName?.charAt(0).toUpperCase();
    });

    const componentClasses = computed(() => {
        return {
            'employee-avatar-icon': true,
            'employee-avatar-icon--smaller': props.smaller,
            'employee-avatar-icon--round': props.round,
        };
    });
</script>

<style scoped lang="scss">
    .employee-avatar-icon {
        width: 64px;
        height: 64px;
        border: solid 2px white;
        border-radius: 10px;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;

        &--smaller {
            width: 48px;
            height: 48px;
            border: solid 1px var(--color-widget);
            border-radius: 5px;
            padding: .1rem;
        }

        &--round {
            border-radius: 25px;
            padding: .1rem;
        }

        &__img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: inherit;
            border-radius: inherit;
        }

        &__initial {
            border-radius: inherit;
            background-color: var(--color-widget);
            font-size: 1.25rem;
            font-weight: 600;
            color: var(--color-widget-text);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
        }
    }
</style>
